// extracted by mini-css-extract-plugin
export default {"userMessage":"UserChatBubble_userMessage__opxSM"};